/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Customer_Invite_Mail_FailedInputs */



/**
* | output |
* | --- |
* | "The email could not be sent, but the link below is valid — pass it on directly." |
*
* @param {Partner_Customer_Invite_Mail_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_customer_invite_mail_failed = /** @type {((inputs?: Partner_Customer_Invite_Mail_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Customer_Invite_Mail_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die E-Mail konnte nicht gesendet werden, der Link unten ist jedoch gültig — geben Sie ihn direkt weiter.")
	return /** @type {LocalizedString} */ ("The email could not be sent, but the link below is valid — pass it on directly.")
});